import { render } from "./ComprehensiveRequestDashboard.vue?vue&type=template&id=223e2a23&scoped=true"
import script from "./ComprehensiveRequestDashboard.vue?vue&type=script&lang=js"
export * from "./ComprehensiveRequestDashboard.vue?vue&type=script&lang=js"

import "./ComprehensiveRequestDashboard.vue?vue&type=style&index=0&id=223e2a23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223e2a23"]])

export default __exports__